import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LoganStatusService } from 'src/app/core/services/loganStatus.service';

@Component({
  selector: 'app-logan-status',
  templateUrl: './logan-status.component.html',
  styleUrls: ['./logan-status.component.scss'],
})
export class LoganStatusComponent implements OnInit {
  constructor(private loganStatusService: LoganStatusService) {}
  status = '';
  ngOnInit(): void {
    this.loganStatusService.loganStatus().subscribe(
      (response: any) => {
        this.status = 'OK';
      },
      (error: HttpErrorResponse) => {
        this.status = 'NOK';
      }
    );
  }
}
